export default __webpack_public_path__ + "static/media/circ-ibz.f699c25a.jpg";